var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useEffect, useCallback } from 'react';
export var useModalObserver = function (_a) {
    var isModalShowing = _a.isModalShowing;
    var _b = __read(useState(false), 2), isIntersectingViewport = _b[0], setIntersected = _b[1];
    var _c = __read(useState(false), 2), isObserverStarted = _c[0], setObserverStarted = _c[1];
    var modalObserver = window
        ? new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.intersectionRatio !== 1) {
                    setIntersected(true);
                }
                else {
                    setIntersected(false);
                }
            });
        }, { threshold: 1 })
        : undefined;
    useEffect(function () {
        return function () { return modalObserver === null || modalObserver === void 0 ? void 0 : modalObserver.disconnect(); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var dialogContentRef = useCallback(function (node) {
        var _a, _b;
        if (isModalShowing && node !== null && !isObserverStarted) {
            (_a = modalObserver === null || modalObserver === void 0 ? void 0 : modalObserver.observe) === null || _a === void 0 ? void 0 : _a.call(modalObserver, node);
            setObserverStarted(true);
        }
        else {
            (_b = modalObserver === null || modalObserver === void 0 ? void 0 : modalObserver.disconnect) === null || _b === void 0 ? void 0 : _b.call(modalObserver);
            setObserverStarted(false);
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isModalShowing]);
    return { isIntersectingViewport: isIntersectingViewport, dialogContentRef: dialogContentRef };
};
//# sourceMappingURL=useModalObserver.js.map